import { ReactComponent as StatusCancelSVG } from '../assets/images/status-cancel.svg';

const StatusCancel = () => {
  return <StatusCancelSVG className="text-alert-yellow" />;
}

export default StatusCancel;
